import { css } from '@/styled-system/css';

export const inputChipIconStyles = css.raw({
  color: 'Chip.icon.default',
  marginInlineEnd: 'Chip.gap.leading',
});
